var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-footer"},[_c('div',{staticClass:"app-footer__inner text-center"},[_vm._v(" Copyright 2023 DashboardPack.com and NCR ")])])
}]

export { render, staticRenderFns }